import { ASYNC_TASK_TYPES } from "@/other/constants/OtherKeys.jsx";

/** Account-level async tasks visible on My Swivu (see origin popover filter matrix). */
export const ACCOUNT_LEVEL_ASYNC_TASK_TYPES = [
  ASYNC_TASK_TYPES.BOARD_DUPLICATION,
  ASYNC_TASK_TYPES.DEMO_BOARD_CREATION,
  ASYNC_TASK_TYPES.BOARD_IMPORT,
  ASYNC_TASK_TYPES.BOARD_EXPORT,
] as const;

export type AccountLevelAsyncTaskType =
  (typeof ACCOUNT_LEVEL_ASYNC_TASK_TYPES)[number];
